import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import TextAreaAutosize from './_text-area-autosize';
import TextAreaInput from './_text-area-input';
import TextInputInput from './_text-input-input';
function isTextInputAutosizeProps(props) {
  let counterProp = false;
  const validUnit = 'unit' in props && props.unit !== undefined && props.unit !== null;
  if ('counter' in props) {
    counterProp = props.counter !== undefined ? props.counter : false;
  }
  const counter = !validUnit && !props.amount && counterProp;
  const counterAutosize = counter && (props.rows === undefined || props.rows < 2);
  if (!validUnit && ('autosize' in props || counterAutosize)) {
    if (counterAutosize) {
      return true;
    }
    return props.autosize === true;
  }
  return false;
}
function isTextareaInputProps(props) {
  const validUnit = 'unit' in props && props.unit !== undefined && props.unit !== null;
  if (props.rows !== undefined && props.rows > 1 && !validUnit) {
    return true;
  }
  return false;
}

/**
 * _A field that allows users to enter and edit information._
 *
 * ***
 *
 * The component renders either an `<input>` or a `<textarea>` with appropriate
 * styling and minimal internal state. Meant primarily for use as a building
 * block for other components, such as the more user-friendly
 * [ValidInput](#/Forms/ValidInput).
 *
 * To use as a controlled component, set the `value` and `onChange` props. For
 * uncontrolled use, the component's `ref` will be forwarded to the HTML element.
 * (Due to implementation details, TextInput `ref` cannot be a function).
 *
 * Props that are not explicitly listed below will be passed to the HTML element
 * (e.g. `className`, `onChange`, `placeholder`, `value`).
 */
export function TextInput(props) {
  if (isTextInputAutosizeProps(props)) {
    return /*#__PURE__*/React.createElement(TextAreaAutosize, props);
  }
  if (isTextareaInputProps(props)) {
    return /*#__PURE__*/React.createElement(TextAreaInput, props);
  }
  return /*#__PURE__*/React.createElement(TextInputInput, props);
}
const Fwd = /*#__PURE__*/forwardRef((props, ref) => {
  if (isTextareaInputProps(props) || isTextInputAutosizeProps(props)) {
    return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
      fwdRef: ref
    }));
  }
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    fwdRef: ref
  }));
});
Fwd.displayName = 'TextInput';
export default Fwd;